import React from "react";

const PageLoading = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <div
        className="h-12 w-12 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"
        role="status"
      />
    </div>
  );
};

export default PageLoading;
